import { useEffect } from 'react';
import { useHistory, useRouteMatch } from 'react-router';

const CommissionReportsPage = () => {
  const history = useHistory();
  const match = useRouteMatch();

  useEffect(() => {
    if (match.isExact) {
      history.replace(`/app/reports/commission/byMoviments`);
    }
  }, [match]);

  return null;
};

export default CommissionReportsPage;
